import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Registration = () => {
  const [registerData, setRegisterData] = useState({
    mobileNo: '',
    passwordHash: '',
    FCMToken: '',
    RestaurantId: '',
    OutletId: ''
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  // Fetch FCM token from localStorage after component mounts
  useEffect(() => {
    const storedFcmToken = localStorage.getItem('fcmToken');
    if (storedFcmToken) {
      setRegisterData((prevData) => ({
        ...prevData,
        FCMToken: storedFcmToken
      }));
    }
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRegisterData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}Auth/register`,
        registerData
      );
      console.log('New Registration Successfully', response.data);
      navigate("/");
      // Reset form fields after successful registration
      setRegisterData({
        mobileNo: '',
        passwordHash: '',
        FCMToken: localStorage.getItem('fcmToken'), // Keeps FCMToken intact
        RestaurantId: '',
        OutletId: ''
      });
    } catch (error) {
      console.log('New Data Registration Failure', error);
    }
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="container-fluid mt-5">
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 p-3 mt-5 text-center shadow p-3 mb-5 bg-body rounded">
          <h3>Register</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-3 mt-4">
              <input
                type="text"
                name="mobileNo"
                placeholder="Enter mobileNo"
                className="form-control"
                value={registerData.mobileNo}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? 'text' : 'password'} // Dynamically change input type
                name="passwordHash"
                placeholder="Enter Password"
                className="form-control"
                value={registerData.passwordHash}
                onChange={handleInputChange}
                required
              />
              <span
                className="position-absolute end-0 top-50 translate-middle-y me-3"
                style={{ cursor: 'pointer' }}
                onClick={togglePasswordVisibility}
              >
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </span>
            </div>
            <div className="mb-3 mt-4">
              <input
                type="text"
                name="RestaurantId"
                placeholder="Restaurant Id"
                className="form-control"
                value={registerData.RestaurantId}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                name="OutletId"
                placeholder="Outlet Id"
                className="form-control"
                value={registerData.OutletId}
                onChange={handleInputChange}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary text-center mt-2">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Registration;
